import React from 'react';
import { TextMarker } from '../../../../../../../_lib/components/TextMarker/TextMarker';
import { SearchSuggestResult } from '../types/SuggestResultTypes';

export interface ListItemSearchSuggestProps {
  suggest: SearchSuggestResult;
}

/**
 * Item in the listbox that features content like linked site headlines.
 */
export default function ListItemSearchSuggest({ suggest }: ListItemSearchSuggestProps) {
  return (
    <div className="combobox__list-item combobox__list-item--searchsuggests">
      <div className="combobox__filename">
        <TextMarker text={suggest.title} type="strong" />
      </div>
    </div>
  );
}
